import CacheService from '../cache-service';
const axios = require('axios');

class TeamMembersService extends CacheService {
  getAll() {
    return this.getCachedData(`/api/team-members`);
  }

  getByName(name) {
    return this.getCachedData(`/api/team-members/${ name }`);
  }
}

const teamMembersService = new TeamMembersService();

export default teamMembersService;